var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "M2.5 13.43a.5.5 0 0 1-.5-.5V5.555a.5.5 0 0 1 .5-.5h3.078V4.5c0-.827.672-1.5 1.5-1.5H8.8c.828 0 1.5.673 1.5 1.5v.556h3.079a.5.5 0 0 1 .492.41l.008.09v7.375a.5.5 0 0 1-.5.5zm2.161-7.375H3v6.375h1.661V6.055zm5.556 0H5.661v6.375h4.556V6.055zm2.662 0h-1.662v6.375h1.662V6.055zM8.8 4H7.078c-.275 0-.5.225-.5.5v.556H9.3V4.5a.5.5 0 0 0-.5-.5z"
  })));
};
export default SvgBriefcase;